// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"142":"analytics","498":"bookonline","882":"BookSlot"}[chunkId] + "." + {"142":"b8b7e8ef","498":"2441e4b6","882":"d02a4e21"}[chunkId] + ".css";
};